import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-freight-rate',
  templateUrl: './freight-rate.component.html',
  styleUrls: ['./freight-rate.component.css']
})
export class FreightRateComponent implements OnInit {
    freightRateKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.freightRateKeyno = this.stateService.getStateParams()['freightrate_keyno'];
    }

    private async loadEdit() {
        if (!!this.freightRateKeyno) {
            this.edit = (await this.datatask.Post(1548, { freightrate_keyno: this.freightRateKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1549, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    freightrate_keyno: string;
    from_supplier_name: string;
    to_stockplace_name: string;
    freightratetype_name: string;
    freight_main_rate_locval: string;
    freight_last_rate_locval: string;
    customs_last_rate_locval: string;
    volume_m3: string;
    isdefault: string;
}
